<template>
	<VSelect
		v-bind="forwardedAttrs"
		:model-value="resolvedValue"
		@update:model-value="onUpdate"
	>
		<template v-for="(_, name) in $slots" #[name]="slotData">
			<slot :name="name" v-bind="slotData || {}" />
		</template>
	</VSelect>
</template>

<script>
import VSelect from "vue-select";

/**
 * Bridges Vue 2-style v-model (value + input) used across the app
 * with vue-select@4 (modelValue + update:modelValue).
 *
 * COMPONENT_V_MODEL: false so parent `v-model` binds to modelValue /
 * update:modelValue first; legacy `@input` side-effects then see fresh state.
 */
export default {
	name: "OvVSelect",
	components: { VSelect },
	inheritAttrs: false,
	// Keep listeners in $attrs (Vue 3) so parent v-on handlers forward via v-bind.
	// COMPONENT_V_MODEL: false so v-model uses modelValue/update:modelValue first,
	// then legacy @input side-effects see updated local state.
	compatConfig: {
		INSTANCE_LISTENERS: false,
		COMPONENT_V_MODEL: false,
	},
	props: {
		modelValue: {},
		value: {},
	},
	emits: ["update:modelValue", "input"],
	computed: {
		resolvedValue() {
			return this.modelValue !== undefined ? this.modelValue : this.value;
		},
		forwardedAttrs() {
			const attrs = { ...this.$attrs };
			delete attrs.value;
			delete attrs.onInput;
			return attrs;
		},
	},
	methods: {
		onUpdate(val) {
			this.$emit("update:modelValue", val);
			this.$emit("input", val);
		},
	},
};
</script>
